<template>
  <el-dialog
    title="编辑竞标单位"
    :visible.sync="dialogVisible"
    width="620px"
    :close-on-click-modal="false"
    append-to-body
    custom-class="bidder-edit-dialog"
    @open="initBidders"
  >
    <div class="project-line">
      <i class="el-icon-office-building"></i>
      <span class="project-name">{{ projectInfo.project }}</span>
    </div>

    <div class="section-title">
      当前竞标单位
      <span class="section-count">{{ bidders.length }} 家</span>
    </div>

    <div class="bidder-list">
      <div v-for="(b, i) in bidders" :key="i" class="bidder-item">
        <span class="bidder-dot" :class="b.won ? 'is-won' : ''"></span>
        <span class="bidder-unit">
          {{ b.unit }}
          <el-tag v-if="b.won" type="success" size="mini" effect="light">中标</el-tag>
          <el-tag v-else-if="b.isCompetitor" type="info" size="mini" effect="plain">竞争方</el-tag>
        </span>
        <span class="bidder-price" :class="{ 'price-won': b.won }">{{ b.price ? formatMoney(b.price) : '—' }}</span>
        <el-button
          v-if="bidders.length > 1"
          type="text"
          class="bidder-del"
          icon="el-icon-delete"
          @click="removeBidder(i)"
        >删除</el-button>
      </div>
      <div v-if="!bidders.length" class="bidder-empty">暂无竞标单位</div>
    </div>

    <div class="section-title">添加竞标单位</div>
    <div class="add-row">
      <el-input v-model="newName" placeholder="公司名称" clearable @keyup.enter.native="addBidder"></el-input>
      <el-input v-model="newPrice" placeholder="报价（可选）" clearable @keyup.enter.native="addBidder"></el-input>
      <el-button type="primary" icon="el-icon-plus" @click="addBidder">添加</el-button>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" :loading="saving" @click="save">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { RAW_DATA, formatMoney, groupByProject } from './bidData'

export default {
  name: 'BidderEditDialog',
  props: {
    visible: { type: Boolean, default: false },
    projectInfo: {
      type: Object,
      default: () => ({ project: '', procurement: '', bidDate: '' })
    }
  },
  data() {
    return {
      saving: false,
      newName: '',
      newPrice: '',
      bidders: []
    }
  },
  computed: {
    dialogVisible: {
      get() { return this.visible },
      set(val) { this.$emit('update:visible', val) }
    }
  },
  methods: {
    formatMoney,
    initBidders() {
      this.newName = ''
      this.newPrice = ''
      const { project, procurement, bidDate } = this.projectInfo
      const all = groupByProject(RAW_DATA.slice())
      const group = all.find(g => g.project === project && g.procurement === procurement && g.bidDate === bidDate)
      this.bidders = group ? group.bidders.map(b => ({ ...b })) : []
    },
    addBidder() {
      const name = this.newName.trim()
      if (!name) {
        this.$message.warning('请输入公司名称')
        return
      }
      this.bidders.push({ unit: name, price: this.newPrice.trim(), won: false, isCompetitor: true })
      this.newName = ''
      this.newPrice = ''
    },
    removeBidder(index) {
      if (this.bidders.length <= 1) {
        this.$message.warning('至少保留一个竞标单位')
        return
      }
      this.bidders.splice(index, 1)
    },
    save() {
      this.saving = true
      setTimeout(() => {
        // 回写竞争公司列到共享 RAW_DATA
        const competitors = this.bidders.filter(b => !b.won).slice(0, 5)
        const { project, procurement, bidDate } = this.projectInfo
        const dateKey = String(bidDate || '').replace(/[^0-9]/g, '').substring(0, 8)
        RAW_DATA.forEach(d => {
          const dk = String(d['开标日期'] || '').replace(/[^0-9]/g, '').substring(0, 8)
          if (d['项目名称'] === project && d['采购单位'] === procurement && dk === dateKey) {
            for (let ci = 1; ci <= 5; ci++) {
              d['竞争公司' + ci] = competitors[ci - 1] ? competitors[ci - 1].unit : ''
            }
          }
        })
        this.saving = false
        this.dialogVisible = false
        this.$emit('saved')
        this.$message.success('竞标单位已更新')
      }, 300)
    }
  }
}
</script>

<style scoped lang="scss">
.project-line {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  background: #f5f8fe;
  border-radius: 8px;
  margin-bottom: 16px;
}
.project-line i {
  color: #409eff;
  font-size: 16px;
  margin-right: 8px;
}
.project-name {
  font-size: 14px;
  color: #1f2d3d;
  font-weight: 600;
  line-height: 1.5;
}

.section-title {
  font-size: 13px;
  font-weight: 600;
  color: #1f2d3d;
  margin: 14px 0 10px;
}
.section-count {
  font-size: $font-size-base;
  color: #909399;
  font-weight: 400;
  margin-left: 6px;
}

.bidder-list {
  border: 1px solid #eef0f4;
  border-radius: 8px;
  padding: 4px 12px;
}
.bidder-item {
  display: flex;
  align-items: center;
  padding: 9px 0;
  border-bottom: 1px dashed #f2f3f5;
}
.bidder-item:last-child { border-bottom: none; }
.bidder-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #409eff;
  flex-shrink: 0;
  margin-right: 10px;
}
.bidder-dot.is-won { background: #36cf63; }
.bidder-unit {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  color: #1f2d3d;
  display: flex;
  align-items: center;
  gap: 6px;
}
.bidder-price {
  font-size: $font-size-base;
  color: #909399;
  margin-right: 12px;
  font-variant-numeric: tabular-nums;
}
.bidder-price.price-won {
  color: #36cf63;
  font-weight: 600;
}
.bidder-del {
  color: #f56c6c;
  padding: 0;
}
.bidder-empty {
  padding: 18px 0;
  text-align: center;
  color: #c0c4cc;
  font-size: 13px;
}

.add-row {
  display: flex;
  gap: 10px;
}
.add-row .el-input { flex: 1; }
</style>
